import styled from 'styled-components';
import { Button as ButtonComponent } from 'components/Button';

export const SearchButtonWrapper = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
`;

export const LeftWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const SearchText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

export const Button = styled(ButtonComponent)`
  &&& {
    height: 40px;
  }
`;
